
export class DocumentRequest {
    name: string;
    url: string;
    alt: string;
    summary: string;
    tags: string;
    copyright: string;
    filename: string;
    
    constructor(){
        this.name ="";
        this.url ="";
        this.alt ="";
        this.summary ="";
        this.tags ="";
        this.copyright ="";
        this.filename ="";
    }
}

export class DocumentRequestList{
    dimPagina:number;
    numeroPagina:number;
    
}


export class DocumentRequestPublish{
    id:number;
    published:boolean;
    
}

export class DocumentRequestSearch{
    filename:string;
    name: string;
    pageNumber: number;
    pageSize: number;
    published: boolean;
    sortBy: string;
    
}
